import { useCallback } from 'react';

import { BestBidOffer } from '../../../../../@types/orderbook';

import {
  formatNumber,
  getTypeByComparison,
  generateColumnGroup,
} from './utils';

import { TableBestBidOfferWrapper } from './styled';

interface TableBestBidOfferProps {
  visible: boolean;
  previous: number;
  data: BestBidOffer;
}

const TableBestBidOffer = (props: TableBestBidOfferProps) => {
  const { visible, data, previous } = props;

  const getColor = useCallback((columnData, dataToCompare): string => {
    if (columnData === 0) return undefined;

    return getTypeByComparison(columnData, dataToCompare);
  }, []);

  const reformatColumnData = useCallback(
    (columnData: string | number): string => {
      if (columnData === 0) return '-';
      return formatNumber(columnData);
    },
    [],
  );

  if (!visible || !data) return null;

  const cellClass = 'orderbook-text-cell';

  return (
    <TableBestBidOfferWrapper>
      {generateColumnGroup()}

      <tbody>
        <tr key="best-bid-offer">
          <td key="best-bid-frequency" className={cellClass}>
            -
          </td>
          <td key="best-bid-lot" className={cellClass}>
            {reformatColumnData(data.bid?.quantity?.raw)}
          </td>
          <td
            key="best-bid-price"
            className={`${cellClass} ${getColor(
              data.bid?.price?.raw,
              previous,
            )}`}
          >
            {reformatColumnData(data.bid?.price?.raw)}
          </td>
          <td
            key="best-offer-price"
            className={`${cellClass} ${getColor(
              data.offer?.price?.raw,
              previous,
            )}`}
          >
            {reformatColumnData(data.offer?.price?.raw)}
          </td>
          <td key="best-offer-lot" className={cellClass}>
            {reformatColumnData(data.offer?.quantity?.raw)}
          </td>
          <td key="best-offer-frequency" className={cellClass}>
            -
          </td>
        </tr>
      </tbody>
    </TableBestBidOfferWrapper>
  );
};

export default TableBestBidOffer;
